import React from 'react'

import PropTypes from 'prop-types'

import { CardMap as ComponentMap } from '@omnilert/components'

const CardMap = ({ className, locations }) => {
  const updatedLocations = locations?.map(({ coords, markerUrl }) => {
    const [lat, lng] = Object.keys(coords).map((key) => coords[key])

    return {
      markerUrl,
      position: { lat, lng }
    }
  })

  const handleOnClickMap = () => {
    // Currently, we do not have the concept of clicking on a pin and grabbing the location.
    // For now there is only one location on the map so it is safe to grab the first index
    const { position: { lat, lng } } = updatedLocations[0]

    const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`

    window.open(url, '_blank')
  }

  const mapContainerStyle = {
    height: '100%',
    width: '100%'
  }

  const center = {
    lat: -31.56391,
    lng: 147.154312
  }

  return (
    <div className={className}>
      <ComponentMap
        center={center}
        locations={updatedLocations}
        mapContainerStyle={mapContainerStyle}
        onClick={handleOnClickMap}
        zoom={16}
      />
    </div>
  )
}

CardMap.defaultProps = {
  locations: null
}

CardMap.propTypes = {
  locations: PropTypes.array.isRequired
}

export default CardMap
